module.exports = __webpack_public_path__ + "static/media/image (37).11ae438c.png";